import { useCallback } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { useData } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/hooks/useData'
import { useHandlers } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/hooks/useHandlers'
import { useActions } from '@user/components/Location/MatchCreateNew/CreateNew/hooks'
import { useMatchLocationTitles } from '@user/components/Location/MatchCreateNew/hooks'

type Params = {
  entityId: number
  entityType: ENTITY_TYPES
  onSaveSuccess?: () => void
}

export function useMatchCreateLocationFlow(params: Params) {
  const { entityId, entityType, onSaveSuccess } = params

  const { matchLocationTitle } = useMatchLocationTitles()
  const createLocParams = useData({ entityId, entityType })

  const onSaveClose = useCallback(() => {
    createLocParams.onClose()
    onSaveSuccess?.()
  }, [createLocParams, onSaveSuccess])

  const { saving, onSave } = useActions({
    ...createLocParams,
    matchLocationTitle,
    onClose: onSaveClose,
  })

  const {
    handleMatchLocation,
    handleCreateNewLocation,
    onClose,
    open,
    openNewLocation,
    onCloseNewLocation,
  } = useHandlers({ ...createLocParams, onSave })

  const onMatchTabsClose = useCallback(() => {
    onClose()
    onSaveSuccess?.()
  }, [onClose, onSaveSuccess])

  return {
    createLocParams,
    matchLocationTitle,
    canUpdateEntity: createLocParams.canUpdateEntity,
    saving,
    handleMatchLocation,
    handleCreateNewLocation,
    matchOverlayOpen: open,
    onMatchOverlayClose: onClose,
    onMatchTabsClose,
    createLocationOpen: openNewLocation,
    onCreateLocationClose: onCloseNewLocation,
  }
}

export type MatchCreateLocationFlow = ReturnType<
  typeof useMatchCreateLocationFlow
>
